import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/iphone 16 bpm game.png'
import _imports_1 from '@/assets/images/arrow.svg'


import BackgroundVideo from "@/components/BackgroundVideo.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackgroundVideo),
    _cache[0] || (_cache[0] = _createElementVNode("main", null, [
      _createElementVNode("h2", null, "Ervaar je hartslag als muziek"),
      _createElementVNode("img", {
        class: "screenshot",
        src: _imports_0,
        alt: "screenshot"
      }),
      _createElementVNode("a", {
        href: "/onze-app",
        class: "read-more"
      }, [
        _createElementVNode("h2", null, [
          _createTextVNode("Lees meer "),
          _createElementVNode("img", {
            class: "arrow",
            src: _imports_1,
            alt: "arrow"
          })
        ])
      ])
    ], -1))
  ], 64))
}
}

})